<div class="discord-migration-welcome">
  <div class="modal-header border-0">
    <h2 class="modal-title fui-heading-font t-24" id="modal-title">{{ "discord_migration.welcome_title" | translate }}</h2>
    <button class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
  </div>

  <div class="modal-body">
    <p class="m-b-15">{{ "discord_migration.welcome_intro" | translate }}</p>
    <p class="m-b-20">{{ "discord_migration.welcome_attribution" | translate }}</p>

    <!-- Signed out: one button, and the round trip brings them back here. -->
    @if (!signedIn) {
      <div class="migration-cta text-center p-20">
        <p class="m-b-15">{{ "discord_migration.signed_out_prompt" | translate }}</p>
        <button class="btn btn-primary" (click)="signIn()">{{ "discord_migration.log_in_or_create" | translate }}</button>
      </div>
    }

    <!-- Signed in: the real linking panel, embedded rather than reimplemented. `compact` drops
         its own "Connections" heading so the copy above stays the frame. -->
    @if (signedIn) {
      <div class="migration-link-panel">
        <h3 class="t-18 bold m-b-10">{{ "discord_migration.link_heading" | translate }}</h3>
        <p class="m-b-15">{{ "discord_migration.link_detail" | translate }}</p>
        <myp-account-connections [compact]="true" [returnTo]="returnTo"></myp-account-connections>
      </div>
    }
  </div>

  <div class="modal-footer border-0">
    <button class="btn btn-blank" (click)="close()">{{ "discord_migration.explore_community" | translate }}</button>
  </div>
</div>
